import React, {useState} from "react";
import {Button, UnderlinedHeader} from "src/components";
import {Member} from "../../model/EstateFlowchartTypes";
import "./_powers-of-appointment-section.scss";
import {TransferType} from "./PoaTransferType";
import {PoaType} from "./PoaType";
import {PowerOfAppointment} from "./PowerOfAppointment";
import PowerOfAppointmentRow from "./PowersOfAppointmentRow";

type PowersOfAppointmentSectionProps = {
    powersOfAppointment: PowerOfAppointment[]
    updateTrust: (newPowersOfAppointments: PowerOfAppointment[]) => void,
    familyMembers: Member[],
    trustIndex: number,
}
export default function PowersOfAppointmentSection({
                                                       powersOfAppointment,
                                                       updateTrust,
                                                       familyMembers,
                                                       trustIndex,
                                                   }: Readonly<PowersOfAppointmentSectionProps>): JSX.Element {

    const [powersOfAppointmentsState, setPowersOfAppointmentsState] = useState<PowerOfAppointment[]>(powersOfAppointment);
    const [operation, setOperation] = useState<"ADD" | "EDIT" | "DELETE" | "VIEW">("VIEW");

    React.useEffect(() => {
        if(powersOfAppointment.length !== powersOfAppointmentsState.length && operation !== "DELETE") {
            setPowersOfAppointmentsState(powersOfAppointment);
        }
    }, [powersOfAppointment]);

    const onAddPowerOfAppointment = () => {
        const poasLength = powersOfAppointmentsState.length;
        const newPoaOrder = poasLength > 0 ? powersOfAppointmentsState[powersOfAppointmentsState.length - 1].poaOrder + 1 : 0;
        const newPowerOfAppointment: PowerOfAppointment = {
            type: PoaType.Limited,
            transferType: TransferType.Testamentary,
            powerHolder: "",
            permissibleAppointees: "",
            additionalDetails: "",
            poaOrder: newPoaOrder,
        }
        const updatedListOfPowersOfAppointment = [...powersOfAppointmentsState, newPowerOfAppointment];
        setPowersOfAppointmentsState(updatedListOfPowersOfAppointment);
        setOperation("ADD");
        updateTrust(updatedListOfPowersOfAppointment);
    }

    const onChangePowerOfAppointment = (index: number, updatedPowerOfAppointment: PowerOfAppointment) => {
        const updatedPowersOfAppointment = powersOfAppointmentsState.map((existingPowerOfAppointment, i) =>
            i === index ? updatedPowerOfAppointment : existingPowerOfAppointment);
        setPowersOfAppointmentsState(updatedPowersOfAppointment);
        setOperation("EDIT");
        updateTrust(updatedPowersOfAppointment);
    }

    const onDeletePowerOfAppointment = async (index: number) => {
        const localPowerOfAppointments = [...powersOfAppointmentsState];
        localPowerOfAppointments.splice(index, 1);
        setPowersOfAppointmentsState(localPowerOfAppointments);
        setOperation("DELETE");
        updateTrust(localPowerOfAppointments);
    }

    return (
        <section className="powers-of-appointment">
            <UnderlinedHeader className={"powers-of-appointment-header"}
                              leftAlignedContent={
                                  <h4>Powers of Appointment</h4>
                              }
                              rightAlignedContent={
                                  <Button
                                      className={"add-powers-of-appointment-button"}
                                      onClick={() => {
                                          onAddPowerOfAppointment()
                                      }}
                                      icon="left"
                                      iconName="add"
                                      kind="borderless"
                                  >
                                      <span className="add-powers-of-appointment-label">ADD POWERS OF APPOINTMENT</span>
                                  </Button>
                              }
            />

            {powersOfAppointmentsState.length > 0 ?
                powersOfAppointmentsState.map((poa, index) => (
                    <PowerOfAppointmentRow
                        key={poa.poaId ?? poa.poaOrder}
                        powerOfAppointmentForm={poa}
                        onChangePOA={(updatedPOA: PowerOfAppointment) => {
                            onChangePowerOfAppointment(index, updatedPOA);
                        }}
                        onDeletePOA={() => onDeletePowerOfAppointment(index)}
                        familyMembers={familyMembers}
                        trustIndex={trustIndex}
                        index={index}
                    />
                )) : null}

            {powersOfAppointmentsState.length > 0 ? (
                <div className={"powers-of-appointment-bottom-button"}>
                    <Button
                        className={"add-powers-of-appointment-button"}
                        onClick={() => {
                            onAddPowerOfAppointment();
                        }}
                        icon="left"
                        iconName="add"
                        kind="borderless"
                    >
                        <span className="add-powers-of-appointment-label">ADD POWERS OF APPOINTMENT</span>
                    </Button>
                </div>
            ) : null}

        </section>
    )
}